import { BulkOperationsStatusStore } from "./BulkOperationStatusReducer"

function getStore(state): BulkOperationsStatusStore {
    return state.bulkOperationsStatusReducer as BulkOperationsStatusStore
}

export function getBulkOperationsStatus(state): string {
    return getStore(state).BulkOperationsStatus
}


// WEBPACK FOOTER //
// ./src/state/bulk-operation/BulkOperationStatusSelector.ts